import Vue from "vue";
import CustomPlugin from "@core/custom/custom";
import FTPClientPlugin from "@core/components/ftp-client/FTPClient";
import { ToastPlugin, ModalPlugin } from "bootstrap-vue";
import VueCompositionAPI from "@vue/composition-api";
import VueExcelXlsx from "vue-excel-xlsx";
import { VueGoodTable } from "vue-good-table";
import store from "@/store/index";
import excel from "vue-excel-export";
import {
  BAlert, BPagination, BFormGroup, BDropdownItem, BDropdown, BFormInput, BInputGroupPrepend, BFormSelect, BFormSelectOption, BRow, BCol,
  VBTooltip, BButton, BCardText, BCard, BCardBody, BLink, BImg, BCardTitle, BInputGroup, BInputGroupAppend, BFormCheckbox, BFormRadioGroup,
  BFormRadio, BForm, BFormTextarea, BFormFile, BBadge, BTable, BFormTimepicker, BMedia, BFormDatepicker, BPopover, VBPopover, BMediaAside,
  BMediaBody, BTabs, BTab, BCardHeader, BAvatar, BFormCheckboxGroup, BFormInvalidFeedback, BFormValidFeedback, BTableSimple, BThead, BTr, BTh, BTd,
  BTbody, BTfoot, BListGroup, BListGroupItem, BDropdownForm
} from "bootstrap-vue";
import BCardCode from "@core/components/b-card-code";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import VueSweetalert2 from "vue-sweetalert2";
import { localize } from "vee-validate";
import { required } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import i18n from "@/libs/i18n";
import vSelect from "vue-select";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import Cleave from "vue-cleave-component";
import Vueditor from "vueditor";
import flatPickr from "vue-flatpickr-component";
import { Turkish } from "flatpickr/dist/l10n/tr.js";
import FlipCountdown from "vue2-flip-countdown";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import VueApexCharts from 'vue-apexcharts'
import AwesomeMask from 'awesome-mask'
import draggable from 'vuedraggable'
import CustomDatePicker from "@core/components/CustomDatePicker.vue";
import FullCalendar from '@fullcalendar/vue'
import BaseTimer from "@/layouts/components/BaseTimer";
import RemindingFolders from "@/layouts/components/RemindingFolders";
import LoginModalForm from "@/layouts/components/LoginModalForm.vue";

//Pages
import AccountGeneralForm from "@/@modules/Forms/Account/AccountGeneralForm.vue";
import AccountPasswordForm from "@/@modules/Forms/Account/AccountPasswordForm.vue";
import Dashboard from '@/views/pages/Dashboard/Dashboard.vue'
import MatterList from "@/@modules/Lists/Matter/MatterList.vue";
import MatterForm from "@/@modules/Forms/Matter/MatterForm.vue";
import ClientsList from "@/@modules/Lists/Clients/ClientsList.vue";
import ClientsForm from "@/@modules/Forms/Clients/ClientsForm.vue";
import LawActivityList from "@/@modules/Lists/Definitions/LawActivityList.vue";
import LawActivityForm from "@/@modules/Forms/Definitions/LawActivityForm.vue";
import LawDecisionList from "@/@modules/Lists/Definitions/LawDecisionList.vue";
import LawDecisionForm from "@/@modules/Forms/Definitions/LawDecisionForm.vue";
import LawMatterFileTypeList from "@/@modules/Lists/Definitions/LawMatterFileTypeList.vue";
import LawMatterFileTypeForm from "@/@modules/Forms/Definitions/LawMatterFileTypeForm.vue";
import LawMatterOutcomeList from "@/@modules/Lists/Definitions/LawMatterOutcomeList.vue";
import LawMatterProcessResultList from "@/@modules/Lists/Definitions/LawMatterProcessResultList.vue";
import LawMatterOutcomeForm from "@/@modules/Forms/Definitions/LawMatterOutcomeForm.vue";
import LawMatterProcessResultForm from "@/@modules/Forms/Definitions/LawMatterProcessResultForm.vue";
import LawMatterStatusList from "@/@modules/Lists/Definitions/LawMatterStatusList.vue";
import LawMatterStatusForm from "@/@modules/Forms/Definitions/LawMatterStatusForm.vue";
import LawMatterTypeList from "@/@modules/Lists/Definitions/LawMatterTypeList.vue";
import LawMatterTypeForm from "@/@modules/Forms/Definitions/LawMatterTypeForm.vue";
import LawSubjectList from "@/@modules/Lists/Definitions/LawSubjectList.vue";
import LawSubjectForm from "@/@modules/Forms/Definitions/LawSubjectForm.vue";
import MatterDocumentList from "@/@modules/Lists/Matter/MatterSubTables/MatterDocumentList.vue";
import MatterDocumentForm from "@/@modules/Forms/Matter/MatterSubForm/MatterDocumentForm.vue";
import MatterNoteList from "@/@modules/Lists/Matter/MatterSubTables/MatterNoteList.vue";
import LawMatterEvidenceDetectionCounterPartyList from "@/@modules/Lists/Matter/MatterSubTables/LawMatterEvidenceDetectionCounterPartyList.vue";
import MatterCustomsRegistrationRenewalList from "@/@modules/Lists/Matter/MatterSubTables/MatterCustomsRegistrationRenewalList.vue";
import MatterNoteForm from "@/@modules/Forms/Matter/MatterSubForm/MatterNoteForm.vue";
import LawMatterEvidenceDetectionCounterPartyForm from "@/@modules/Forms/Matter/MatterSubForm/LawMatterEvidenceDetectionCounterPartyForm.vue";
import MatterPlaintiffList from "@/@modules/Lists/Matter/MatterSubTables/MatterPlaintiffList.vue";
import MatterPlaintiffForm from "@/@modules/Forms/Matter/MatterSubForm/MatterPlaintiffForm.vue";
import MatterDefendantList from "@/@modules/Lists/Matter/MatterSubTables/MatterDefendantList.vue";
import MatterDefendantForm from "@/@modules/Forms/Matter/MatterSubForm/MatterDefendantForm.vue";
import MatterConsultingForm from "@/@modules/Forms/Matter/MatterSubForm/MatterConsultingForm.vue";
import MatterBudgetList from "@/@modules/Lists/Matter/MatterSubTables/MatterBudgetList.vue";
import MatterBudgetForm from "@/@modules/Forms/Matter/MatterSubForm/MatterBudgetForm.vue";
import MatterFirstInstanceCourtList from "@/@modules/Lists/Matter/MatterSubTables/MatterFirstInstanceCourtList.vue";
import MatterFirstInstanceCourtForm from "@/@modules/Forms/Matter/MatterSubForm/MatterFirstInstanceCourtForm.vue";
import MatterFinalizationList from "@/@modules/Lists/Matter/MatterSubTables/MatterFinalizationList.vue";
import MatterFinalizationForm from "@/@modules/Forms/Matter/MatterSubForm/MatterFinalizationForm.vue";
import MatterAppealInfoList from "@/@modules/Lists/Matter/MatterSubTables/MatterAppealInfoList.vue";
import MatterAppealInfoForm from "@/@modules/Forms/Matter/MatterSubForm/MatterAppealInfoForm.vue";
import MatterDecisionAdjustmentsList from "@/@modules/Lists/Matter/MatterSubTables/MatterDecisionAdjustmentsList.vue";
import MatterDecisionAdjustmentsForm from "@/@modules/Forms/Matter/MatterSubForm/MatterDecisionAdjustmentsForm.vue";
import MatterSupremeCourtList from "@/@modules/Lists/Matter/MatterSubTables/MatterSupremeCourtList.vue";
import MatterTypeHistoryList from "@/@modules/Lists/Matter/MatterSubTables/MatterTypeHistoryList.vue";
import MatterSupremeCourtForm from "@/@modules/Forms/Matter/MatterSubForm/MatterSupremeCourtForm.vue";
import MatterRegionalCourtOfAppealList from "@/@modules/Lists/Matter/MatterSubTables/MatterRegionalCourtOfAppealList.vue";
import MatterRegionalCourtOfAppealForm from "@/@modules/Forms/Matter/MatterSubForm/MatterRegionalCourtOfAppealForm.vue";
import MatterCautionList from "@/@modules/Lists/Matter/MatterSubTables/MatterCautionList.vue";
import MatterCautionForm from "@/@modules/Forms/Matter/MatterSubForm/MatterCautionForm.vue";
import MatterSecurityDepositForm from "@/@modules/Forms/Matter/MatterSubForm/MatterSecurityDepositForm.vue";
import MatterEvidenceDetectionForm from "@/@modules/Forms/Matter/MatterSubForm/MatterEvidenceDetectionForm.vue";
import MatterProfessionalInvestigationForm from "@/@modules/Forms/Matter/MatterSubForm/MatterProfessionalInvestigationForm.vue";
import MatterSimplifiedDestructionForm from "@/@modules/Forms/Matter/MatterSubForm/MatterSimplifiedDestructionForm.vue";
import MatterCustomsRegistrationForm from "@/@modules/Forms/Matter/MatterSubForm/MatterCustomsRegistrationForm.vue";
import MatterCustomsRegistrationRenewalForm from "@/@modules/Forms/Matter/MatterSubForm/MatterCustomsRegistrationRenewalForm.vue";
import MatterStopCustomsForm from "@/@modules/Forms/Matter/MatterSubForm/MatterStopCustomsForm.vue";
import MatterTakeDownRequestForm from "@/@modules/Forms/Matter/MatterSubForm/MatterTakeDownRequestForm.vue";
import MatterSmugglingForm from "@/@modules/Forms/Matter/MatterSubForm/MatterSmugglingForm.vue";
import MatterCriminalComplaintForm from "@/@modules/Forms/Matter/MatterSubForm/MatterCriminalComplaintForm.vue";
import MatterDamagesClaimForm from "@/@modules/Forms/Matter/MatterSubForm/MatterDamagesClaimForm.vue";
import MatterMonitoringSurveillanceForm from "@/@modules/Forms/Matter/MatterSubForm/MatterMonitoringSurveillanceForm.vue";
import MatterLegalEvidenceSamplesForm from "@/@modules/Forms/Matter/MatterSubForm/MatterLegalEvidenceSamplesForm.vue";
import MatterTradeFairForm from "@/@modules/Forms/Matter/MatterSubForm/MatterTradeFairForm.vue";
import MatterLegalNoticeForm from "@/@modules/Forms/Matter/MatterSubForm/MatterLegalNoticeForm.vue";
import MatterMatterInfoForm from "@/@modules/Forms/Matter/MatterSubForm/MatterMatterInfoForm.vue";
import MatterMediationForm from "@/@modules/Forms/Matter/MatterSubForm/MatterMediationForm.vue";
import InvoiceList from "@/@modules/Lists/Finance/InvoiceList.vue";
import InvoiceDetailReportList from "@/@modules/Lists/Finance/InvoiceDetailReportList.vue";
import LawEventList from "./@modules/Lists/LawEvent/LawEventList.vue";
import InvoiceForm from "@/@modules/Forms/Finance/InvoiceForm.vue";
import InvoiceAddDailyworkForm from "@/@modules/Forms/Finance/InvoiceAddDailyworkForm.vue";
import PaymentList from "@/@modules/Lists/Finance/PaymentList.vue";
import PaymentForm from "@/@modules/Forms/Finance/PaymentForm.vue";
import DailyworkReportList from "@/@modules/Lists/Matter/MatterSubTables/Dailywork/DailyworkReportList.vue";
import DailyworkList from "@/@modules/Lists/Matter/MatterSubTables/Dailywork/DailyworkList.vue";
import DailyworkForm from "@/@modules/Forms/Matter/MatterSubForm/DailyworkForm.vue";
import AgingReportList from "@/@modules/Lists/Reports/AgingReportList.vue";
import CancelledInvoiceList from "@/@modules/Lists/Reports/CancelledInvoiceList.vue";
import CostAccountingList from "@/@modules/Lists/Reports/CostAccountingList.vue";
import CreditNotesList from "@/@modules/Lists/Reports/CreditNotesList.vue";
import ExpenseReportList from "@/@modules/Lists/Reports/ExpenseReportList.vue";
import InvoiceCodeReportList from "@/@modules/Lists/Reports/InvoiceCodeReportList.vue";
import InvoiceCodeReportForm from "@/@modules/Forms/Reports/InvoiceCodeReport/InvoiceCodeReportForm.vue";
import InvoiceCodeReportDetailForm from "@/@modules/Forms/Reports/InvoiceCodeReport/InvoiceCodeReportSubForm/InvoiceCodeReportDetailForm.vue";
import LawyerDailyworkReportList from "@/@modules/Lists/Reports/LawyerDailyworkReportList.vue";
import MatterReportList from "@/@modules/Lists/Reports/MatterReportList.vue";
import VouchersList from "@/@modules/Lists/Reports/VouchersList.vue";
import ReminderReportList from "@/@modules/Lists/Reminder/ReminderReportList.vue";
import ReminderForm from "@/@modules/Forms/Reminder/ReminderForm.vue";
import EmployeeList from "@/@modules/Lists/Definitions/EmployeeList.vue";
import EmployeeForm from "@/@modules/Forms/Definitions/EmployeeForm.vue";
import EmployeePhotoCropperForm from "@/@modules/Forms/Definitions/EmployeeSubForm/EmployeePhotoCropperForm.vue";
import LawMatterEvidenceList from "@/@modules/Lists/Matter/MatterSubTables/LawMatterEvidenceList.vue";
import LawMatterEvidenceForm from "@/@modules/Forms/Matter/MatterSubForm/LawMatterEvidenceForm.vue";
import MatterAddMatterTypeForm from "@/@modules/Forms/Matter/MatterSubForm/MatterAddMatterTypeForm.vue";
import LawEventForm from "./@modules/Forms/LawEvent/LawEventForm.vue";
import LawCourtList from "@/@modules/Lists/Definitions/LawCourtList.vue";
import LawCounterPartyList from "@/@modules/Lists/Definitions/LawCounterPartyList.vue";
import LawCounterPartyAttorneyList from "@/@modules/Lists/Definitions/LawCounterPartyAttorneyList.vue";
import LawCourtForm from "@/@modules/Forms/Definitions/LawCourtForm.vue";
import LawCounterPartyForm from "@/@modules/Forms/Definitions/LawCounterPartyForm.vue";
import LawCounterPartyAttorneyForm from "@/@modules/Forms/Definitions/LawCounterPartyAttorneyForm.vue";
import InvoiceDetailList from "@/@modules/Lists/Finance/InvoiceDetailList.vue"
import LawClientPowerOfAttorneyDeadlineReportList from "@/@modules/Lists/Reports/LawClientPowerOfAttorneyDeadlineReportList.vue"
import ClientsAccountingForm from "@/@modules/Forms/Clients/ClientsSubForm/ClientsAccountingForm.vue"
import ClientsAccountingList from "@/@modules/Lists/Clients/ClientsSubTables/ClientsAccountingList.vue"
import ClientNoteList from "@/@modules/Lists/Clients/ClientsSubTables/ClientNoteList.vue"
import ClientNoteForm from "@/@modules/Forms/Clients/ClientsSubForm/ClientNoteForm.vue"
import LawInvoiceUpdateDetailForm from "@/@modules/Forms/Finance/InvoiceSubForms/LawInvoiceUpdateDetailForm.vue"
import ClientsInvoiceCodeList from "@/@modules/Lists/Clients/ClientsSubTables/ClientsInvoiceCodeList.vue";
import LawMatterCourtExpertForm from "./@modules/Forms/Matter/MatterSubForm/LawMatterCourtExpertForm.vue";
import LawMatterCourtExpertList from "./@modules/Lists/Matter/MatterSubTables/LawMatterCourtExpertList.vue";
import LawMatterTradeFairEmployeeForm from "./@modules/Forms/Matter/MatterSubForm/LawMatterTradeFairEmployeeForm.vue";
import LawMatterTradeFairEmployeeList from "./@modules/Lists/Matter/MatterSubTables/LawMatterTradeFairEmployeeList.vue";
import LawMatterCustomsRegistrationListOfLast1MonthExpirationDateReportList from "./@modules/Lists/Reports/LawMatterCustomsRegistrationListOfLast1MonthExpirationDateReportList.vue";
import ExpertForm from "./@modules/Forms/Expert/ExpertForm.vue";
import ExpertList from "./@modules/Lists/Expert/ExpertList.vue";
import LawDocumentContentTypeForm from "./@modules/Forms/Definitions/LawDocumentContentTypeForm.vue";
import LawDocumentContentTypeList from "./@modules/Lists/Definitions/LawDocumentContentTypeList.vue";
import LawDailyworkDescriptionForm from "./@modules/Forms/Definitions/LawDailyworkDescriptionForm.vue";
import LawDailyworkDescriptionList from "./@modules/Lists/Definitions/LawDailyworkDescriptionList.vue";
import LawDailyworkDescriptionSelectionForm from "./@modules/Forms/Finance/InvoiceSubForms/LawDailyworkDescriptionSelectionForm.vue";
import AddNewLawClientForm from "./@modules/Forms/Clients/ClientsSubForm/AddNewLawClientForm.vue";
import InvoiceApprovalList from "./@modules/Lists/Finance/InvoiceApprovalList.vue";
import LawNoteToBeOnInvoiceForm from "./@modules/Forms/Definitions/LawNoteToBeOnInvoiceForm.vue";
import LawNoteToBeOnInvoiceList from "./@modules/Lists/Definitions/LawNoteToBeOnInvoiceList.vue";
import ClientsReportsForm from "./@modules/Forms/Clients/ClientsReports/ClientsReportsForm.vue";
import DashboardCalendar from '@/views/pages/Dashboard/DashboardCalendar.vue'
import ClientInvoiceList from "./@modules/Lists/Clients/ClientsSubTables/ClientInvoiceList.vue";
import ClientContactList from "./@modules/Lists/Clients/ClientsSubTables/ClientContactList.vue";
import ClientResponsibleList from "./@modules/Lists/Clients/ClientsSubTables/ClientResponsibleList.vue";
import LawMatterBudgetReportForm from "./@modules/Forms/Matter/MatterSubForm/LawMatterBudgetReportForm.vue";
import LawMatterBudgetReportBilledAttorneyFeeList from "./@modules/Lists/Reports/LawMatterBudgetReport/LawMatterBudgetReportBilledAttorneyFeeList.vue";
import LawMatterBudgetReportBilledExpensesList from "./@modules/Lists/Reports/LawMatterBudgetReport/LawMatterBudgetReportBilledExpensesList.vue";
import LawMatterBudgetReportNonBilledAttorneyFeeList from "./@modules/Lists/Reports/LawMatterBudgetReport/LawMatterBudgetReportNonBilledAttorneyFeeList.vue";
import LawMatterBudgetReportNonBilledExpensesList from "./@modules/Lists/Reports/LawMatterBudgetReport/LawMatterBudgetReportNonBilledExpensesList.vue";
import PaymentDetailList from "./@modules/Lists/Finance/Payment/PaymentSubLists/PaymentDetailList.vue";
import LawLedesCodeTypeForm from "./@modules/Forms/Definitions/LawLedes/LawLedesCodeTypeForm.vue";
import LawLedesCodeTypeList from "./@modules/Lists/Definitions/LawLedes/LawLedesCodeTypeList.vue";
import LawMatterSubSubjectList from "./@modules/Lists/Definitions/LawMatterSubSubjectList.vue";
import LawMatterSubSubjectForm from "./@modules/Forms/Definitions/LawMatterSubSubjectForm.vue";
import LawExpertOpinionOutcomeList from "./@modules/Lists/Definitions/LawExpertOpinionOutcomeList.vue";
import LawExpertOpinionOutcomeForm from "./@modules/Forms/Definitions/LawExpertOpinionOutcomeForm.vue";
import LawMatterSubjectList from "./@modules/Lists/Definitions/LawMatterSubjectList.vue";
import LawMatterSubjectForm from "./@modules/Forms/Definitions/LawMatterSubjectForm.vue";
import LawMatterSubSubjectTableForm from "./@modules/Forms/Definitions/LawMatterSubSubjectTableForm.vue";
import LawLedesTypeForm from "./@modules/Forms/Definitions/LawLedes/LawLedesTypeForm.vue";
import LawLedesTypeList from "./@modules/Lists/Definitions/LawLedes/LawLedesTypeList.vue";
import LawProductCategoryList from "./@modules/Lists/Definitions/LawProductCategoryList.vue";
import LawDamagesClaimTypeList from "./@modules/Lists/Definitions/LawDamagesClaimTypeList.vue";
import LawTradeFairSubjectList from "./@modules/Lists/Definitions/LawTradeFairSubjectList.vue";
import LawTradeFairCenterList from "./@modules/Lists/Definitions/LawTradeFairCenterList.vue";
import LawTradeFairList from "./@modules/Lists/Definitions/LawTradeFairList.vue";
import LawTypeOfViolationList from "./@modules/Lists/Definitions/LawTypeOfViolationList.vue";
import LawProfessionalInvestigationTypeList from "./@modules/Lists/Definitions/LawProfessionalInvestigationTypeList.vue";
import LawProfessionalInvestigationRegionList from "./@modules/Lists/Definitions/LawProfessionalInvestigationRegionList.vue";
import LawSecurityDepositTypeList from "./@modules/Lists/Definitions/LawSecurityDepositTypeList.vue";
import LawSecurityDepositMethodList from "./@modules/Lists/Definitions/LawSecurityDepositMethodList.vue";
import LawSecurityDepositClientRefundMethodList from "./@modules/Lists/Definitions/LawSecurityDepositClientRefundMethodList.vue";
import LawAuthorityCategoryList from "./@modules/Lists/Definitions/LawAuthorityCategoryList.vue";
import LawAuthoritySubCategoryList from "./@modules/Lists/Definitions/LawAuthoritySubCategoryList.vue";
import LawMediationResultList from "./@modules/Lists/Definitions/LawMediationResultList.vue";
import LawEventTypeList from "./@modules/Lists/Definitions/LawEventTypeList.vue";
import LawAuthorityTypeList from "./@modules/Lists/Definitions/LawAuthorityTypeList.vue";
import LawAuthorityList from "./@modules/Lists/Definitions/LawAuthorityList.vue";
import LawAuthorityRepresentativeList from "./@modules/Lists/Definitions/LawAuthorityRepresentativeList.vue";
import LawCounterPartyTypeList from "./@modules/Lists/Definitions/LawCounterPartyTypeList.vue";
import LawCounterPartySubTypeList from "./@modules/Lists/Definitions/LawCounterPartySubTypeList.vue";
import LawProductCategoryForm from "./@modules/Forms/Definitions/LawProductCategoryForm.vue";
import LawDamagesClaimTypeForm from "./@modules/Forms/Definitions/LawDamagesClaimTypeForm.vue";
import LawTradeFairSubjectForm from "./@modules/Forms/Definitions/LawTradeFairSubjectForm.vue";
import LawTradeFairCenterForm from "./@modules/Forms/Definitions/LawTradeFairCenterForm.vue";
import LawTradeFairForm from "./@modules/Forms/Definitions/LawTradeFairForm.vue";
import LawTypeOfViolationForm from "./@modules/Forms/Definitions/LawTypeOfViolationForm.vue";
import LawProfessionalInvestigationTypeForm from "./@modules/Forms/Definitions/LawProfessionalInvestigationTypeForm.vue";
import LawProfessionalInvestigationRegionForm from "./@modules/Forms/Definitions/LawProfessionalInvestigationRegionForm.vue";
import LawSecurityDepositTypeForm from "./@modules/Forms/Definitions/LawSecurityDepositTypeForm.vue";
import LawSecurityDepositMethodForm from "./@modules/Forms/Definitions/LawSecurityDepositMethodForm.vue";
import LawSecurityDepositClientRefundMethodForm from "./@modules/Forms/Definitions/LawSecurityDepositClientRefundMethodForm.vue";
import LawAuthorityCategoryForm from "./@modules/Forms/Definitions/LawAuthorityCategoryForm.vue";
import LawAuthoritySubCategoryForm from "./@modules/Forms/Definitions/LawAuthoritySubCategoryForm.vue";
import LawMediationResultForm from "./@modules/Forms/Definitions/LawMediationResultForm.vue";
import LawEventTypeForm from "./@modules/Forms/Definitions/LawEventTypeForm.vue";
import LawAuthorityTypeForm from "./@modules/Forms/Definitions/LawAuthorityTypeForm.vue";
import LawAuthorityForm from "./@modules/Forms/Definitions/LawAuthorityForm.vue";
import LawAuthorityRepresentativeForm from "./@modules/Forms/Definitions/LawAuthorityRepresentativeForm.vue";
import LawCounterPartyTypeForm from "./@modules/Forms/Definitions/LawCounterPartyTypeForm.vue";
import LawCounterPartySubTypeForm from "./@modules/Forms/Definitions/LawCounterPartySubTypeForm.vue";
import LawLedesList from "./@modules/Lists/Finance/LawLedes/LawLedesList.vue";
import LawLedesForm from "./@modules/Forms/Finance/LawLedes/LawLedesForm.vue";
import LawLedesDetailList from "./@modules/Lists/Finance/LawLedes/LawLedesDetailList.vue";
import LawLedesDetailForm from "./@modules/Forms/Finance/LawLedes/LawLedesDetailForm.vue";
import LawLedesExcelReadForm from "./@modules/Forms/Finance/LawLedes/LawLedesExcelReadForm.vue";
import AuthControlForm from "./views/pages/Login/AuthControlForm.vue";
import LawLawyerInvoiceReportList from "./@modules/Lists/Reports/LawLawyerInvoiceReportList.vue";
import CreateLawInvoiceLedesForm from "./@modules/Forms/Finance/InvoiceSubForms/CreateLawInvoiceLedesForm.vue";
import LawClientAccountingLedesList from "./@modules/Lists/Clients/ClientsSubTables/LawClientAccountingLedesList.vue";
import PreviewESMMInvoiceForm from "./@modules/Forms/Finance/PreviewESMMInvoiceForm.vue";
import OwnersList from "@/@modules/Lists/Owners/OwnersList.vue";
import OwnersForm from "@/@modules/Forms/Owners/OwnersForm.vue";

//components
Vue.component("BCardHeader", BCardHeader);
Vue.component("BCardText", BCardText);
Vue.component("VueGoodTable", VueGoodTable);
Vue.component("BPagination", BPagination);
Vue.component("BFormGroup", BFormGroup);
Vue.component("BForm", BForm);
Vue.component("BBadge", BBadge);
Vue.component("BFormTextarea", BFormTextarea);
Vue.component("BFormInput", BFormInput);
Vue.component("BFormSelect", BFormSelect);
Vue.component("BFormSelectOption", BFormSelectOption);
Vue.component("BMedia", BMedia);
Vue.component("BAvatar", BAvatar);
Vue.component("BPopover", BPopover);
Vue.component("BTable", BTable);
Vue.component("BMediaAside", BMediaAside);
Vue.component("BMediaBody", BMediaBody);
Vue.component("BRow", BRow);
Vue.component("BCol", BCol);
Vue.component("BTabs", BTabs);
Vue.component("BTab", BTab);
Vue.component("BDropdownForm", BDropdownForm);
Vue.component("BFormFile", BFormFile);
Vue.component("BButton", BButton);
Vue.component("BInputGroup", BInputGroup);
Vue.component("BInputGroupPrepend", BInputGroupPrepend);
Vue.component("BInputGroupAppend", BInputGroupAppend);
Vue.component("BFormCheckbox", BFormCheckbox);
Vue.component("BFormRadioGroup", BFormRadioGroup);
Vue.component("BFormRadio", BFormRadio);
Vue.component("AppCollapseItem", AppCollapseItem);
Vue.component("AppCollapse", AppCollapse);
Vue.component("BCardCode", BCardCode);
Vue.component("BCard", BCard);
Vue.component("BLink", BLink);
Vue.component("BImg", BImg);
Vue.component("VuexyLogo", VuexyLogo);
Vue.component("BCardTitle", BCardTitle);
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("required", required);
Vue.component("vSelect", vSelect);
Vue.component("BFormCheckboxGroup", BFormCheckboxGroup);
Vue.component("BFormInvalidFeedback", BFormInvalidFeedback);
Vue.component("BFormValidFeedback", BFormValidFeedback);
Vue.component("BDropdownItem", BDropdownItem);
Vue.component("BDropdown", BDropdown);
Vue.component("Cleave", Cleave);
Vue.component("BCardBody", BCardBody);
Vue.component("flatPickr", flatPickr);
Vue.component("FlipCountdown", FlipCountdown);
Vue.component("BFormDatepicker", { extends: BFormDatepicker, props: { startWeekday: { default: 1 } } });
Vue.component("BTableSimple", BTableSimple);
Vue.component("BThead", BThead);
Vue.component("BTr", BTr);
Vue.component("BTh", BTh);
Vue.component("BTd", BTd);
Vue.component("BTbody", BTbody);
Vue.component("BTfoot", BTfoot);
Vue.component("BListGroup", BListGroup);
Vue.component("BListGroupItem", BListGroupItem);
Vue.component("BFormTimepicker", BFormTimepicker);
Vue.component("VueApexCharts", VueApexCharts);
Vue.component("draggable", draggable)
Vue.component("BAlert", BAlert)
Vue.component("CustomDatePicker", CustomDatePicker);
Vue.component("BaseTimer", BaseTimer);
Vue.component("RemindingFolders", RemindingFolders);
// Vue.component('Loading', Loading);
Vue.use(Loading);
Vue.component("FormWizard", FormWizard);
Vue.component("TabContent", TabContent);
Vue.component("FullCalendar", FullCalendar);

//Pages for component
Vue.component("AccountGeneralForm", AccountGeneralForm);
Vue.component("AccountPasswordForm", AccountPasswordForm);
Vue.component("Dashboard", Dashboard);
Vue.component("MatterList", MatterList);
Vue.component("MatterForm", MatterForm);
Vue.component("ClientsList", ClientsList);
Vue.component("ClientsForm", ClientsForm);
Vue.component("LawActivityList", LawActivityList);
Vue.component("LawActivityForm", LawActivityForm);
Vue.component("LawDecisionList", LawDecisionList);
Vue.component("LawDecisionForm", LawDecisionForm);
Vue.component("LawMatterFileTypeList", LawMatterFileTypeList);
Vue.component("LawMatterFileTypeForm", LawMatterFileTypeForm);
Vue.component("LawMatterOutcomeList", LawMatterOutcomeList);
Vue.component("LawMatterProcessResultList", LawMatterProcessResultList);
Vue.component("LawMatterOutcomeForm", LawMatterOutcomeForm);
Vue.component("LawMatterProcessResultForm", LawMatterProcessResultForm);
Vue.component("LawMatterStatusList", LawMatterStatusList);
Vue.component("LawMatterStatusForm", LawMatterStatusForm);
Vue.component("LawMatterTypeList", LawMatterTypeList);
Vue.component("LawMatterTypeForm", LawMatterTypeForm);
Vue.component("LawSubjectList", LawSubjectList);
Vue.component("LawSubjectForm", LawSubjectForm);
Vue.component("InvoiceList", InvoiceList);
Vue.component("InvoiceDetailReportList", InvoiceDetailReportList);
Vue.component("LawEventList",LawEventList)
Vue.component("InvoiceForm", InvoiceForm);
Vue.component("InvoiceAddDailyworkForm", InvoiceAddDailyworkForm);
Vue.component("MatterDocumentList", MatterDocumentList);
Vue.component("MatterDocumentForm", MatterDocumentForm);
Vue.component("MatterNoteList", MatterNoteList);
Vue.component("LawMatterEvidenceDetectionCounterPartyList", LawMatterEvidenceDetectionCounterPartyList);
Vue.component("MatterCustomsRegistrationRenewalList", MatterCustomsRegistrationRenewalList);
Vue.component("MatterNoteForm", MatterNoteForm);
Vue.component("LawMatterEvidenceDetectionCounterPartyForm", LawMatterEvidenceDetectionCounterPartyForm);
Vue.component("MatterPlaintiffList", MatterPlaintiffList);
Vue.component("MatterPlaintiffForm", MatterPlaintiffForm);
Vue.component("MatterDefendantList", MatterDefendantList);
Vue.component("MatterDefendantForm", MatterDefendantForm);
Vue.component("MatterConsultingForm", MatterConsultingForm);
Vue.component("MatterBudgetList", MatterBudgetList);
Vue.component("MatterBudgetForm", MatterBudgetForm);
Vue.component("MatterFirstInstanceCourtList", MatterFirstInstanceCourtList);
Vue.component("MatterFirstInstanceCourtForm", MatterFirstInstanceCourtForm);
Vue.component("MatterFinalizationList", MatterFinalizationList);
Vue.component("MatterFinalizationForm", MatterFinalizationForm);
Vue.component("MatterAppealInfoList", MatterAppealInfoList);
Vue.component("MatterAppealInfoForm", MatterAppealInfoForm);
Vue.component("MatterDecisionAdjustmentsList", MatterDecisionAdjustmentsList);
Vue.component("MatterDecisionAdjustmentsForm", MatterDecisionAdjustmentsForm);
Vue.component("MatterSupremeCourtList", MatterSupremeCourtList);
Vue.component("MatterTypeHistoryList", MatterTypeHistoryList);
Vue.component("MatterSupremeCourtForm", MatterSupremeCourtForm);
Vue.component("MatterRegionalCourtOfAppealList", MatterRegionalCourtOfAppealList);
Vue.component("MatterRegionalCourtOfAppealForm", MatterRegionalCourtOfAppealForm);
Vue.component("MatterCautionList", MatterCautionList);
Vue.component("MatterCautionForm", MatterCautionForm);
Vue.component("MatterSecurityDepositForm", MatterSecurityDepositForm);
Vue.component("MatterEvidenceDetectionForm", MatterEvidenceDetectionForm);
Vue.component("MatterProfessionalInvestigationForm", MatterProfessionalInvestigationForm);
Vue.component("MatterSimplifiedDestructionForm", MatterSimplifiedDestructionForm);
Vue.component("MatterCustomsRegistrationForm", MatterCustomsRegistrationForm);
Vue.component("MatterCustomsRegistrationRenewalForm", MatterCustomsRegistrationRenewalForm);
Vue.component("MatterStopCustomsForm", MatterStopCustomsForm);
Vue.component("MatterTakeDownRequestForm", MatterTakeDownRequestForm);
Vue.component("MatterSmugglingForm", MatterSmugglingForm);
Vue.component("MatterCriminalComplaintForm", MatterCriminalComplaintForm);
Vue.component("MatterDamagesClaimForm", MatterDamagesClaimForm);
Vue.component("MatterMonitoringSurveillanceForm", MatterMonitoringSurveillanceForm);
Vue.component("MatterLegalEvidenceSamplesForm", MatterLegalEvidenceSamplesForm);
Vue.component("MatterTradeFairForm", MatterTradeFairForm);
Vue.component("MatterLegalNoticeForm", MatterLegalNoticeForm);
Vue.component("MatterMatterInfoForm", MatterMatterInfoForm);
Vue.component("MatterMediationForm", MatterMediationForm);
Vue.component("PaymentList", PaymentList);
Vue.component("PaymentForm", PaymentForm);
Vue.component("InvoiceList", InvoiceList);
Vue.component("InvoiceForm", InvoiceForm);
Vue.component("LawEventForm",LawEventForm)
Vue.component("DailyworkReportList", DailyworkReportList);
Vue.component("DailyworkList", DailyworkList);
Vue.component("DailyworkForm", DailyworkForm);
Vue.component("AgingReportList", AgingReportList);
Vue.component("CancelledInvoiceList", CancelledInvoiceList);
Vue.component("CostAccountingList", CostAccountingList);
Vue.component("CreditNotesList", CreditNotesList);
Vue.component("ExpenseReportList", ExpenseReportList);
Vue.component("InvoiceCodeReportList", InvoiceCodeReportList);
Vue.component("InvoiceCodeReportForm", InvoiceCodeReportForm);
Vue.component("InvoiceCodeReportDetailForm", InvoiceCodeReportDetailForm);
Vue.component("LawyerDailyworkReportList", LawyerDailyworkReportList);
Vue.component("MatterReportList", MatterReportList);
Vue.component("VouchersList", VouchersList);
Vue.component("ReminderReportList", ReminderReportList);
Vue.component("ReminderForm", ReminderForm);
Vue.component("EmployeeList", EmployeeList);
Vue.component("EmployeeForm", EmployeeForm);
Vue.component("EmployeePhotoCropperForm", EmployeePhotoCropperForm);
Vue.component("LawMatterEvidenceList", LawMatterEvidenceList);
Vue.component("LawMatterEvidenceForm", LawMatterEvidenceForm);
Vue.component("MatterAddMatterTypeForm", MatterAddMatterTypeForm);
Vue.component("LawCourtList", LawCourtList);
Vue.component("LawCounterPartyList", LawCounterPartyList);
Vue.component("LawCounterPartyAttorneyList", LawCounterPartyAttorneyList);
Vue.component("LawCourtForm", LawCourtForm);
Vue.component("LawCounterPartyForm", LawCounterPartyForm);
Vue.component("LawCounterPartyAttorneyForm", LawCounterPartyAttorneyForm);
Vue.component("InvoiceDetailList", InvoiceDetailList);
Vue.component("LawClientPowerOfAttorneyDeadlineReportList", LawClientPowerOfAttorneyDeadlineReportList)
Vue.component("ClientsAccountingForm", ClientsAccountingForm);
Vue.component("ClientsAccountingList", ClientsAccountingList);
Vue.component("ClientNoteList", ClientNoteList);
Vue.component("ClientNoteForm", ClientNoteForm);
Vue.component("LawInvoiceUpdateDetailForm", LawInvoiceUpdateDetailForm);
Vue.component("ClientsInvoiceCodeList", ClientsInvoiceCodeList);
Vue.component("LawMatterCourtExpertList", LawMatterCourtExpertList);
Vue.component("LawMatterCourtExpertForm", LawMatterCourtExpertForm);
Vue.component("LawMatterTradeFairEmployeeList", LawMatterTradeFairEmployeeList);
Vue.component("LawMatterTradeFairEmployeeForm", LawMatterTradeFairEmployeeForm);
Vue.component("ExpertList", ExpertList);
Vue.component("ExpertForm", ExpertForm);
Vue.component("LawDocumentContentTypeList", LawDocumentContentTypeList);
Vue.component("LawDocumentContentTypeForm", LawDocumentContentTypeForm);
Vue.component("LawDailyworkDescriptionForm", LawDailyworkDescriptionForm);
Vue.component("LawDailyworkDescriptionList", LawDailyworkDescriptionList);
Vue.component("LawDailyworkDescriptionSelectionForm",LawDailyworkDescriptionSelectionForm);
Vue.component("LawMatterCustomsRegistrationListOfLast1MonthExpirationDateReportList", LawMatterCustomsRegistrationListOfLast1MonthExpirationDateReportList);
Vue.component("AddNewLawClientForm",AddNewLawClientForm);
Vue.component("InvoiceApprovalList",InvoiceApprovalList);
Vue.component("LawNoteToBeOnInvoiceList",LawNoteToBeOnInvoiceList);
Vue.component("LawNoteToBeOnInvoiceForm",LawNoteToBeOnInvoiceForm);
Vue.component("ClientsReportsForm",ClientsReportsForm);
Vue.component("DashboardCalendar",DashboardCalendar);
Vue.component("ClientInvoiceList",ClientInvoiceList);
Vue.component("ClientContactList",ClientContactList);
Vue.component("ClientResponsibleList",ClientResponsibleList);
Vue.component("LawMatterBudgetReportForm",LawMatterBudgetReportForm);
Vue.component("LawMatterBudgetReportBilledAttorneyFeeList",LawMatterBudgetReportBilledAttorneyFeeList);
Vue.component("LawMatterBudgetReportBilledExpensesList",LawMatterBudgetReportBilledExpensesList);
Vue.component("LawMatterBudgetReportNonBilledAttorneyFeeList",LawMatterBudgetReportNonBilledAttorneyFeeList);
Vue.component("LawMatterBudgetReportNonBilledExpensesList",LawMatterBudgetReportNonBilledExpensesList);
Vue.component("PaymentDetailList",PaymentDetailList);
Vue.component("LawLedesCodeTypeForm",LawLedesCodeTypeForm);
Vue.component("LawLedesCodeTypeList",LawLedesCodeTypeList);
Vue.component("LawMatterSubSubjectList",LawMatterSubSubjectList);
Vue.component("LawMatterSubSubjectForm",LawMatterSubSubjectForm);
Vue.component("LawExpertOpinionOutcomeList",LawExpertOpinionOutcomeList);
Vue.component("LawExpertOpinionOutcomeForm",LawExpertOpinionOutcomeForm);
Vue.component("LawMatterSubjectList",LawMatterSubjectList);
Vue.component("LawMatterSubjectForm",LawMatterSubjectForm);
Vue.component("LawMatterSubSubjectTableForm",LawMatterSubSubjectTableForm);
Vue.component("LawLedesTypeForm",LawLedesTypeForm);
Vue.component("LawLedesTypeList",LawLedesTypeList);
Vue.component("LawProductCategoryList",LawProductCategoryList);
Vue.component("LawDamagesClaimTypeList",LawDamagesClaimTypeList);
Vue.component("LawTradeFairSubjectList",LawTradeFairSubjectList);
Vue.component("LawTradeFairCenterList",LawTradeFairCenterList);
Vue.component("LawTradeFairList",LawTradeFairList);
Vue.component("LawTypeOfViolationList",LawTypeOfViolationList);
Vue.component("LawProfessionalInvestigationTypeList",LawProfessionalInvestigationTypeList);
Vue.component("LawProfessionalInvestigationRegionList",LawProfessionalInvestigationRegionList);
Vue.component("LawSecurityDepositTypeList",LawSecurityDepositTypeList);
Vue.component("LawSecurityDepositMethodList",LawSecurityDepositMethodList);
Vue.component("LawSecurityDepositClientRefundMethodList",LawSecurityDepositClientRefundMethodList);
Vue.component("LawAuthorityCategoryList",LawAuthorityCategoryList);
Vue.component("LawAuthoritySubCategoryList",LawAuthoritySubCategoryList);
Vue.component("LawMediationResultList",LawMediationResultList);
Vue.component("LawEventTypeList",LawEventTypeList);
Vue.component("LawAuthorityTypeList",LawAuthorityTypeList);
Vue.component("LawAuthorityList",LawAuthorityList);
Vue.component("LawAuthorityRepresentativeList",LawAuthorityRepresentativeList);
Vue.component("LawCounterPartyTypeList",LawCounterPartyTypeList);
Vue.component("LawCounterPartySubTypeList",LawCounterPartySubTypeList);
Vue.component("LawProductCategoryForm",LawProductCategoryForm);
Vue.component("LawDamagesClaimTypeForm",LawDamagesClaimTypeForm);
Vue.component("LawTradeFairSubjectForm",LawTradeFairSubjectForm);
Vue.component("LawTradeFairCenterForm",LawTradeFairCenterForm);
Vue.component("LawTradeFairForm",LawTradeFairForm);
Vue.component("LawTypeOfViolationForm",LawTypeOfViolationForm);
Vue.component("LawProfessionalInvestigationTypeForm",LawProfessionalInvestigationTypeForm);
Vue.component("LawProfessionalInvestigationRegionForm",LawProfessionalInvestigationRegionForm);
Vue.component("LawSecurityDepositTypeForm",LawSecurityDepositTypeForm);
Vue.component("LawSecurityDepositMethodForm",LawSecurityDepositMethodForm);
Vue.component("LawSecurityDepositClientRefundMethodForm",LawSecurityDepositClientRefundMethodForm);
Vue.component("LawAuthorityCategoryForm",LawAuthorityCategoryForm);
Vue.component("LawAuthoritySubCategoryForm",LawAuthoritySubCategoryForm);
Vue.component("LawMediationResultForm",LawMediationResultForm);
Vue.component("LawEventTypeForm",LawEventTypeForm);
Vue.component("LawAuthorityTypeForm",LawAuthorityTypeForm);
Vue.component("LawAuthorityForm",LawAuthorityForm);
Vue.component("LawAuthorityRepresentativeForm",LawAuthorityRepresentativeForm);
Vue.component("LawCounterPartyTypeForm",LawCounterPartyTypeForm);
Vue.component("LawCounterPartySubTypeForm",LawCounterPartySubTypeForm);
Vue.component("LawLedesList",LawLedesList);
Vue.component("LawLedesForm",LawLedesForm);
Vue.component("LawLedesDetailList", LawLedesDetailList);
Vue.component("LawLedesDetailForm", LawLedesDetailForm);
Vue.component("LawLedesExcelReadForm", LawLedesExcelReadForm);
Vue.component("AuthControlForm", AuthControlForm);
Vue.component("LawLawyerInvoiceReportList",LawLawyerInvoiceReportList);
Vue.component("LoginModalForm", LoginModalForm);
Vue.component("CreateLawInvoiceLedesForm", CreateLawInvoiceLedesForm);
Vue.component("LawClientAccountingLedesList", LawClientAccountingLedesList);
Vue.component("PreviewESMMInvoiceForm",PreviewESMMInvoiceForm);
Vue.component("OwnersList", OwnersList);
Vue.component("OwnersForm", OwnersForm);

import "vueditor/dist/style/vueditor.min.css";
import '@core/scss/vue/libs/vue-select.scss';
let config = {
  toolbar: [
    "removeFormat",
    "undo",
    "redo",
    "|",
    "element",
    "fontName",
    "fontSize",
    "foreColor",
    "backColor",
    "divider",
    "bold",
    "italic",
    "underline",
    "strikeThrough",
    "link",
    "unLink",
    "divider",
    "subscript",
    "superscript",
    "divider",
    "justifyLeft",
    "justifyCenter",
    "justifyRight",
    "justifyFull",
    "|",
    "indent",
    "outdent",
    "insertOrderedList",
    "insertUnorderedList",
    "|",
    "picture",
    "table",
    "|",
    "code",
    "fullscreen",
    "sourceCode",
    "markdown",
  ],
  fontName: [
    { val: "arial black" },
    { val: "times new roman" },
    { val: "Courier New" },
  ],
  fontSize: [
    "12px",
    "14px",
    "16px",
    "18px",
    "20px",
    "24px",
    "28px",
    "32px",
    "36px",
  ],
  uploadUrl: "",
  id: "",
  classList: [],
};
Vue.use(Vueditor, config);


//flatpickr language
if (sessionStorage.languageValue == 'tr') {
  flatpickr.localize(Turkish);
}
// flatpickr.localize(languageForFlatPickr);

//directives
Vue.directive("b-tooltip", VBTooltip);
Vue.directive("b-popover", VBPopover);
Vue.directive("mask", AwesomeMask);
//use
Vue.use(VueSweetalert2);

import "@core/scss/vue/libs/vue-good-table.scss";
import "@core/scss/vue/libs/vue-context.scss";
import "@core/scss/vue/libs/vue-sweetalert.scss";
import "@core/scss/vue/libs/vue-flatpicker.scss";
import router from "./router";
import App from "./App.vue";

//Manuel Created Components

// Global Components
import "./global-components";

// 3rd party plugins
import "@/libs/portal-vue";
import "@/libs/toastification";
import "@/libs/sweet-alerts";
import dayGridPlugin from '@fullcalendar/daygrid'

import app from "./store/app";

// BSV Plugin Registration
Vue.use(ToastPlugin);
Vue.use(ModalPlugin);
Vue.use(VueExcelXlsx);
Vue.use(store);
Vue.use(dayGridPlugin);

// Composition API
Vue.use(VueCompositionAPI);
Vue.use(CustomPlugin);
Vue.use(FTPClientPlugin);
Vue.use(excel);

// import core styles
require("@core/scss/core.scss");

Vue.mixin(togglePasswordVisibility);

// import assets styles
require("@/assets/scss/style.scss");

//diğer dillerin eklenmesi için core/utils/validations/validations.js içinden dil eklenmesi gerekiyor.
localize("tr");

Vue.config.productionTip = false;

// Güvenlik: RoleId, EmployeeId, DepartmentId localStorage'dan değil,
// sunucu imzalı JWT token'dan okunur — kullanıcı manipüle edemez.
;(function () {
  const _originalGetItem = Storage.prototype.getItem
  const _tokenKeyMap = { RoleId: 'roleId', EmployeeId: 'id', DepartmentId: 'departmentId' }

  Storage.prototype.getItem = function (key) {
    if (_tokenKeyMap[key]) {
      const token = _originalGetItem.call(this, 'accessToken')
      if (token) {
        try {
          const payload = JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString('utf-8'))
          const value = payload[_tokenKeyMap[key]]
          return value !== undefined ? String(value) : null
        } catch (e) { /* token parse hatası */ }
      }
      return null
    }
    return _originalGetItem.call(this, key)
  }
})()

new Vue({
  router,
  store,
  i18n,
  silentTranslationWarn: true,
  render: (h) => h(App),
}).$mount("#app");
